import { I as Icon, _ as _extends } from './Icon-BnBRpux5.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const AccountingLicense = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M6 1.7988h12c1.2151 0 2.2001.985 2.2001 2.2v16c0 1.2151-.985 2.2-2.2001 2.2H6c-1.215 0-2.2-.9849-2.2-2.2v-16c0-1.215.985-2.2 2.2-2.2zM9 6c-.5523 0-1 .4477-1 1s.4477 1 1 1h6c.5523 0 1-.4477 1-1s-.4477-1-1-1H9zm0 4c-.5523 0-1 .4477-1 1s.4477 1 1 1 1-.4477 1-1-.4477-1-1-1zm2 1c0-.5523.4477-1 1-1s1 .4477 1 1-.4477 1-1 1-1-.4477-1-1zm4-1c-.5523 0-1 .4477-1 1s.4477 1 1 1 1-.4477 1-1-.4477-1-1-1zm-7 4c0-.5523.4477-1 1-1s1 .4477 1 1-.4477 1-1 1-1-.4477-1-1zm4-1c-.5523 0-1 .4477-1 1s.4477 1 1 1 1-.4477 1-1-.4477-1-1-1zm2 1c0-.5523.4477-1 1-1s1 .4477 1 1-.4477 1-1 1-1-.4477-1-1zm-5 2c-.5523 0-1 .4477-1 1s.4477 1 1 1 1-.4477 1-1-.4477-1-1-1zm2 1c0-.5523.4477-1 1-1s1 .4477 1 1-.4477 1-1 1-1-.4477-1-1zm4-1c-.5523 0-1 .4477-1 1s.4477 1 1 1 1-.4477 1-1-.4477-1-1-1z",
      clipRule: "evenodd"
    }),
    stroke: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M17.9998 1.8008h-12c-1.215 0-2.2.985-2.2 2.2v16c0 1.215.985 2.2 2.2 2.2h12c1.215 0 2.2-.985 2.2-2.2v-16c0-1.215-.985-2.2-2.2-2.2zm-12 2.2h12v16h-12v-16z",
      clipRule: "evenodd"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7.9998 7.002c0-.5523.4477-1 1-1h6c.5523 0 1 .4477 1 1 0 .5522-.4477 1-1 1h-6c-.5523 0-1-.4478-1-1zM7.9998 11.002c0-.5523.4477-1 1-1 .5522 0 1 .4477 1 1 0 .5522-.4478 1-1 1-.5523 0-1-.4478-1-1zM10.9998 11.002c0-.5523.4477-1 1-1 .5522 0 1 .4477 1 1 0 .5522-.4478 1-1 1-.5523 0-1-.4478-1-1zM13.9998 11.002c0-.5523.4477-1 1-1 .5522 0 1 .4477 1 1 0 .5522-.4478 1-1 1-.5523 0-1-.4478-1-1zM7.9998 14.002c0-.5523.4477-1 1-1 .5522 0 1 .4477 1 1 0 .5522-.4478 1-1 1-.5523 0-1-.4478-1-1zM10.9998 14.002c0-.5523.4477-1 1-1 .5522 0 1 .4477 1 1 0 .5522-.4478 1-1 1-.5523 0-1-.4478-1-1zM13.9998 14.002c0-.5523.4477-1 1-1 .5522 0 1 .4477 1 1 0 .5522-.4478 1-1 1-.5523 0-1-.4478-1-1zM7.9998 17.002c0-.5523.4477-1 1-1 .5522 0 1 .4477 1 1 0 .5522-.4478 1-1 1-.5523 0-1-.4478-1-1zM10.9998 17.002c0-.5523.4477-1 1-1 .5522 0 1 .4477 1 1 0 .5522-.4478 1-1 1-.5523 0-1-.4478-1-1zM13.9998 17.002c0-.5523.4477-1 1-1 .5522 0 1 .4477 1 1 0 .5522-.4478 1-1 1-.5523 0-1-.4478-1-1z"
    }))
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
AccountingLicense.displayName = "AccountingLicenseIcon";

export { AccountingLicense, AccountingLicense as default };
